import { FormList, FormShape, FormUnit, type GetFormInput } from "@suse-o11y/signal/form";

import { isStringDirty } from "~/tools/is-string-dirty";

import { type DashboardStaticListVariable, dashboardStaticListVariableSchema } from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";

const valueSchema = dashboardStaticListVariableSchema.shape.values
	.removeCatch()
	.sourceType()
	.element.removeCatch()
	.unwrap();

export type StaticValueState = FormShape<{
	value: FormUnit<string, ReadonlyArray<string>>;
	label: FormUnit<string, ReadonlyArray<string>, undefined | string>;
}>;

const INITIAL = {
	value: "",
	label: "",
} satisfies GetFormInput<StaticValueState>;

function initStaticValueState(initial: GetFormInput<StaticValueState> = INITIAL): StaticValueState {
	return FormShape({
		value: FormUnit(initial?.value, {
			isInputDirty: isStringDirty,
			schema: valueSchema.shape.value,
		}),
		label: FormUnit(initial?.label, {
			isInputDirty: isStringDirty,
			schema: valueSchema.shape.label.removeCatch(),
		}),
	});
}

export type FormState = FormList<StaticValueState>;

export const Processor: FormProcessor<FormState, undefined | DashboardStaticListVariable> = {
	fromSpec: (spec) => {
		const initial = spec?.values.length
			? spec.values.map(({ value, label }) => ({
					value: value ?? INITIAL.value,
					label: label ?? INITIAL.label,
				}))
			: [INITIAL];

		return FormList(initStaticValueState, { initial });
	},

	toSpec: (values) => ({
		values: values.map(({ value, label }) => ({ value, label })),
	}),
};
